<template>
  <div class="mx-10 mt-2">
    <div>
      <BackButton @back="onPressBack('My Documents')" />
    </div>
    <v-card elevation="2" class="px-4 pb-4 my-1">
      <div>
        <div class="flex items-center w-full pt-10">
          <div class="w-1/2">
            <v-text-field
              outlined
              class="mr-2"
              placeholder="Purpose of Submitting Documents"
            ></v-text-field>
          </div>
          <div class="w-full">
            <v-autocomplete
              outlined
              label="Please select from the list"
              :items="purposeList"
              v-model="selectedPurpose"
              item-text="purpose"
              return-object
              autocomplete
            ></v-autocomplete>
          </div>
        </div>
        <div>Add brief description of the attached file here:</div>
        <div>
          <TextAreaComp class="my-1" />
          <TextAreaComp class="my-1" />
          <TextAreaComp class="my-1" />
        </div>
        <div class="flex justify-end py-2">
          <v-btn small>Add More</v-btn>
        </div>
        <div><input type="text" /> <input type="text" /></div>
        <div>
          <div>
            You may leave a brief message for our Customer Service
            Representative here.
            <v-textarea
              outlined
              placeholder="150 characters only"
              error-count=""
              name=""
              label=""
              v-model="message"
            ></v-textarea>
          </div>
        </div>
        <div class="flex justify-center">
          <v-btn @click="submit"> Submit Documents</v-btn>
        </div>
      </div>
    </v-card>
    <div>
      <!-- dialog  -->
      <v-dialog
        v-model="dialog"
        persistent
        width="50%"
        :overlay="false"
        transition="dialog-transition"
      >
        <div class="bg_dialog">
          <div class="text-center p-20 dia_bg">
            <h1 class="text-xl">We have received the attached files.</h1>
            <div>
              These will undergo assessment. You will receive an email for any
              queries or concerns we may have about the attachments.
            </div>
          </div>
          <div class="px-10 py-10 pt-10 flex justify-center">
            <v-btn dark class="w-1/2 mr-2" color="black" to="/my-documents"
              >Go to Home Page</v-btn
            >
            <v-btn dark class="w-1/2" color="black" to="/home/dashboard"
              >Go to Dashboard</v-btn
            >
          </div>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import BackButton from "../../../common/BackButton.vue";
import axios from "axios";
import TextAreaComp from "@/screens/myDocumentsScreen/SubmitDocumentsScreen/components/TextArea.vue";
export default {
  data() {
    return {
      dialog: false,
      purposeList: [],
      selectedPurpose: null,
      message: null,
    };
  },
  components: { TextAreaComp, BackButton },
  watch: {
    "$route.name": {
      handler(e) {
        if (e) {
          this.getPurposeOfSubmittingRequest();
        }
      },
      immediate: true,
    },
  },
  methods: {
    onPressBack(e) {
      this.$router.push({ name: e });
    },
    submit() {
      this.dialog = true;
    },
    getPurposeOfSubmittingRequest() {
      axios.get("/purpose_submission/get").then((res) => {
        this.purposeList = res.data;
      });
    },
  },
};
</script>

<style scoped>
.hd1 {
  background: #e9967a;
}
.submit {
  background: #e9967a;
}
.bg_dialog {
  background: #faebd7;
}
</style>